<template>
  <div
    class="main-header"
    :class="{
      resizedHeader: playbackVideoStatus || getVideoCallStatus,
      fullWidthHeader: screenSharingEnabled || fullScreenEnabled
    }"
  >
    <!-- Static navbar -->
    <!-- on small devices "navbaropen" class should apply to nav -->
    <nav class="navbar navbar-expand-lg" :class="{ navbaropen: opened }">
      <div class="dropdown added-margin dropdown-menu-hide-scroll">
        <div class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i v-if="!user.profileImage" class="fa fa-user-o user_icon mr-10" aria-hidden="true"></i>
          <img class="user-icon-image" v-if="user.profileImage" :src="user.profileImage" />
          <span class="user-display">Welcome, {{ userName.firstName }}&nbsp;{{ userName.lastName }}</span>
          <span class="caret"></span>
        </div>
        <ul class="dropdown-menu">
          <router-link tag="li" class="drop_down_list_item" :to="{ name: 'profile', params: { id: user.id } }">My Profile </router-link>
          <li class="drop_down_list_item border-none" @click="logout">
            Log Out
          </li>
        </ul>
      </div>
      <!-- horizontal Navbar start-->
      <div class="nav-wrapper ml-auto d-sm-none d-xs-none d-md-none desk-view-studie">
        <ul class="navbar-nav color_ff right_links">
          <!-- TODO: refactor role access -->
          <router-link tag="li" to="/activity-library" v-if="canSysAdminAccess || canStudyAdminAccess">Activity Library</router-link>
          <router-link
            tag="li"
            to="/clients"
            v-if="
              user && user.licenseType === 'Thread' && user.userRole !== 'Pi' && user.userRole !== 'SubPi' && user.userRole !== 'StudyCoordinator' && user.userRole !== 'HomeHealth' && user.userRole !== 'SiteDataLock' && !user.readOnly && user.userRole !== 'Rater' && user.userRole !== 'StudyManager' && user.userRole !== 'Interviewer' && user.userRole !== 'CallCenter' && user.userRole !== 'Support'
            "
            >Clients</router-link
          >
          <router-link tag="li" to="/studies">Studies</router-link>
          <router-link tag="li" to="/users" v-if="canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess || canSupportAccess"> Team</router-link>
          <a v-if="canNotificationAccess() && totalNotificationCount > 0" tag="li" @click="goToNotification()">
            <span v-if="$route.params.studyId" data-toggle="tooltip" title="Portal Notifications">
              <span class="pl-20 action bell-image">
                <img src="static/img/notification/On-white@2x.png" class="bell" />
              </span>
              <span class="badge badge-rectangle" v-if="unreadCount > 0">
                <span v-if="unreadCount > 99">99+</span>
                <span v-else>{{ unreadCount }}</span>
              </span>
            </span>
          </a>
        </ul>
      </div>
      <!-- horizontal Navbar start-->
      <!-- sidebar-button start-->
      <div class="header-name-wrap text-center fs-18">
        <div v-if="this.$route.fullPath === '/studies'" class="text-white d-sm-block d-xs-block d-md-none d-lg-none">
          Studies
        </div>
        <div v-else-if="this.$route.name === 'dashboard'" class="text-white d-sm-block d-xs-block d-md-none d-lg-none">
          {{ name }}
        </div>
        <div v-else-if="this.$route.name === 'study-participants-list'" class="text-white d-sm-block d-xs-block d-md-none d-lg-none">
          Participant list
        </div>
      </div>

      <!-- <div class="toggle-wrapper ml-auto d-block d-md-none d-lg-none "> -->
      <div class="toggle-wrapper ml-auto d-block d-custom-lg-none">
        <span class="open-slide navbaropen">
          <button style="all: unset; cursor: pointer;" @click="opened = !opened">
            <div class="close-slide-icon">
              <div class="bar" :class="{ topopen: opened }"></div>
              <div class="bar" :class="{ midopen: opened }"></div>
              <div class="bar" :class="{ botopen: opened }"></div>
            </div>
          </button>
        </span>
      </div>

      <!-- Navbar section start -->
      <!--/.nav-collapse -->
      <!-- on small devices ".sidenavopen" class should apply to nav -->
      <div id="side-menu" class="side-nav" :class="{ sidenavopen: opened }">
        <div class="nav-wrapper pb-10">
          <ul class="nav navbar-nav color_ff right_links">
            <!-- TODO: refactor role access -->
            <router-link tag="li" to="/activity-library" v-if="canSysAdminAccess || user.userRole === 'StudyAdmin'">Activity Library</router-link>
            <router-link tag="li" to="/clients" v-if="user && user.licenseType === 'Thread' && user.userRole !== 'Pi' && user.userRole !== 'SubPi' && user.userRole !== 'StudyCoordinator' && user.userRole !== 'HomeHealth' && user.userRole !== 'SiteDataLock' && !user.readOnly"> Clients</router-link>
            <router-link tag="li" to="/studies">Studies</router-link>
            <router-link tag="li" to="/users" v-if="canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess"> Team</router-link>
            <a v-if="canNotificationAccess() && totalNotificationCount > 0" tag="li" @click="goToNotification()" class="d-none">
              <span v-if="$route.params.studyId" data-toggle="tooltip" title="Portal Notifications">
                <span class="pl-20 action bell-image">
                  <img src="static/img/notification/On-white@2x.png" class="bell" />
                </span>
                <span class="badge badge-rectangle" v-if="unreadCount > 0">
                  <span v-if="unreadCount > 99">99+</span>
                  <span v-else>{{ unreadCount }}</span>
                </span>
              </span>
            </a>
          </ul>
        </div>
        <div class="dashboard-menu-wrapper" v-if="dashboardPath">
          <SideMenuLink class="menu-item" faIcon="fa-tachometer" :to="{ name: 'dashboard', params: { studyId: studyId } }" :title="name" @click="opened = !opened" />
          <SideMenuLink v-if="analyticsEnabled" class="menu-item" faIcon="fa-bar-chart" :to="{ name: 'analytics', params: { studyId: studyId } }" title="Analytics" @click="opened = !opened" />
          <SideMenuLink class="menu-item" v-if="canSysAdminAccess || canStudyAdminAccess || canQualityAccess" icon="static/img/side-menu-icons/icn-team.svg" activeIcon="static/img/side-menu-icons/icn-team-active.svg" :to="{ name: 'study-admins', params: { studyId: studyId } }" title="Research Team" @click="opened = !opened" />

          <SideMenuLink
            class="menu-item"
            v-if="canPiAccess || canSubPiAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canSiteDataLockAccess || user.readOnly"
            icon="static/img/side-menu-icons/icn-team.svg"
            activeIcon="static/img/side-menu-icons/icn-team-active.svg"
            :to="{
              name: 'site-details',
              params: { studyId: studyId, siteId: selectedSiteId }
            }"
            title="Site Team"
            @click="opened = !opened"
          />

          <SideMenuLink
            class="menu-item"
            icon="static/img/side-menu-icons/icn-participant.svg"
            activeIcon="static/img/side-menu-icons/icn-participant-active.svg"
            :to="{
              name: 'study-participants-list',
              params: { studyId: studyId }
            }"
            title="Participants"
            @click="opened = !opened"
          />
          <SideMenuLink class="menu-item" icon="static/img/side-menu-icons/icn-view-study.svg" activeIcon="static/img/side-menu-icons/icn-view-study-active.svg" :to="{ name: 'study-details', params: { studyId: studyId } }" title="Study Details" @click="opened = !opened" />

          <SideMenuLink class="menu-item" v-if="studyData.web === true && (canSysAdminAccess || canStudyAdminAccess)" icon="static/img/participant-web-img/side-menu-icon.png" activeIcon="static/img/participant-web-img/web-icon.png" :to="{ name: 'global', params: { studyId } }" title="Participant Web" @click="opened = !opened" />

          <SideMenuLink class="menu-item" v-if="canSysAdminAccess || canStudyAdminAccess" icon="/static/img/side-menu-icons/icn-modify.svg" activeIcon="/static/img/side-menu-icons/icn-modify.svg" :to="{ name: 'study-summary', params: { studyId } }" v-on:click.native="modifyStudy()" title="Modify Study" @click.exact="opened = !opened" />
          <SideMenuLink class="menu-item" v-if="(canSysAdminAccess || canStudyAdminAccess) && edcEnabled" faIcon="fa-file-text" :to="{ name: 'forms-list', params: { studyId } }" title="Data capture forms" @click="opened = !opened" />

          <SideMenuLink class="menu-item" icon="static/img/side-menu-icons/icn-participant.svg" activeIcon="static/img/side-menu-icons/icn-participant-active.svg" :to="{ name: 'resource-list-site', params: { studyId } }" :count="newResourceCount" :title="resourceValue" @click="opened = !opened" />
        </div>
      </div>
      <div class="border-line"></div>
    </nav>
  </div>
</template>
<script>
import { SYSTEM_ADMIN, STUDY_ADMIN, STUDY_MANAGER, PI, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, QUALITY, SITEDATALOCK, SUPPORT } from "@/constants/authRoles";
import { mapGetters, mapActions } from "vuex";
import { AclRule } from "vue-acl";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import SyncClient from "twilio-sync";
import localStorageService from "@/services/localStorage";
import SideMenuLink from "./side-menu-link";
import _ from "lodash";
import jwtDecode from "jwt-decode";

export default {
  name: "MainHeader",
  components: {
    SideMenuLink
  },
  data() {
    return {
      studyId: this.$route.params.studyId,
      dashboardPath: false,
      opened: false,
      unreadCount: "",
      studyData: {},
      edcEnabled: false,
      screenSharingEnabled: false,
      playbackVideoStatus: false,
      twilioDocumentSID: "",
      twilioToken: "",
      totalNotificationCount: "",
      fullScreenEnabled: false,
      analyticsEnabled: false,
      selectedSiteId: "",
      userDefineSiteId: "",
      newResourceCount: 0,
      resourceValue: "Resources",
      name: "Dashboard",
      userName: {
        firstName: "",
        lastName: ""
      }
    };
  },
  computed: {
    ...mapGetters(["user", "getVideoCallStatus"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canView() {
      return this.studyData.truClinicIntegration;
    },
    canTelehealthView() {
      return this.studyData.telehealthIntegration;
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPiAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    isTelehealthEnabledForCountry() {
      return (
        this.user.countries &&
        _.chain(this.user.countries)
          .filter({ isTelehealthEnabled: true })
          .size()
          .value() > 0
      );
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    }
  },
  created() {
    if (this.$route.params.studyId) {
      this.getParticularPIrole();
      this.getStudyDetails();
      this.getToggledFeatures();
      setTimeout(() => {
        this.getMaterialCount();
      }, 3000);
    }
    this.getunreadCount();
    setInterval(() => {
      this.getunreadCount();
    }, 60000);
  },
  mounted() {
    // hide the side panel if screen sharing is enabled
    if (this.$route.params.studyId) {
      this.dashboardPath = true;
      this.$root.$on("resource_uploaded", () => {
        setTimeout(() => {
          this.getMaterialCount();
        }, 3000);
      });
      this.getUserObj();
    }
    const token = localStorageService.getItem("token");
    const tokenObj = jwtDecode(token);
    this.userName.firstName = tokenObj.firstName;
    this.userName.lastName = tokenObj.lastName;
    this.screenSharingEnabled = localStorageService.getItem("isScreenSharingEnabled");
    this.$root.$on("screenSharingStarted", () => {
      this.screenSharingEnabled = localStorageService.getItem("isScreenSharingEnabled");
    });
    this.$root.$on("screenSharingEnded", () => {
      this.screenSharingEnabled = localStorageService.getItem("isScreenSharingEnabled");
    });
    this.$root.$on("switchScreen", data => {
      if (data.type == "thPanel") {
        this.playbackVideoStatus = true;
        this.screenSharingEnabled = false;
        this.$forceUpdate();
      } else {
        this.playbackVideoStatus = false;
        this.screenSharingEnabled = true;
      }
    });
    this.$root.$on("playBackVideoEnded", () => {
      this.playbackVideoStatus = false;
    });

    this.$root.$on("fullScreen", value => {
      this.fullScreenEnabled = value;
    });
  },
  methods: {
    ...mapActions(["userLogout", "setStudyToggledFeaturesData", "setSiteDetailsData"]),
    logout() {
      localStorage.removeItem("selectedSite");
      this.$api.logUserlogoutFact(this.user.id).then(
        () => {
          this.userLogout();
        },
        () => {
          this.userLogout();
        }
      );
    },
    canNotificationAccess() {
      if (this.user.userRole === "Pi" || this.user.userRole === "SubPi" || this.user.userRole === "StudyCoordinator" || this.user.userRole === "HomeHealth" || this.user.userRole === "Cra" || this.user.userRole === "Dm" || this.user.userRole === "Quality" || this.user.userRole === "CallCenter" || this.user.userRole === "CraUB") {
        return true;
      } else {
        return false;
      }
    },
    //Get notification list
    goToNotification() {
      this.$router.push({
        name: "notification-list"
      });
    },
    // Function to get notification count
    getunreadCount() {
      if (this.$route.params && this.$route.params.studyId && this.canNotificationAccess()) {
        this.$api.getUnreadCount(this.$route.params.studyId, this.user.id).then(
          response => {
            this.unreadCount = response.body.unreadCount;
            this.totalNotificationCount = response.body.totalNotificationCount;
            this.twilioDocumentSID = response.body.twilioDocumentSID;
            this.twilioToken = response.body.twilioToken;
            this.$forceUpdate();
            this.getUnreadCountByTwilio();
          },
          error => {
            nprogress.done();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications unread count.");
          }
        );
      }
    },
    getUnreadCountByTwilio() {
      if (!this.twilioToken || this.twilioToken == "" ) return;
      const syncClient = new SyncClient(this.twilioToken, {
        logLevel: "info"
      });
      syncClient.document(this.twilioDocumentSID).then(document => {
        document.on("updated", event => {
          this.unreadCount = event.value.unreadCount;
          this.$forceUpdate();
        });
      });
    },
    getToggledFeatures() {
      this.$api.getToggleFeaturesFact(this.studyId).then(
        response => {
          this.setStudyToggledFeaturesData(response.body.studyFeatures);
          window.localStorage.removeItem("toggledFeatures");
          window.localStorage.setItem("toggledFeatures", JSON.stringify(response.body.studyFeatures));
          this.toggleFeatures = response.body.studyFeatures;
          this.$root.$emit("toggledfeaturesEmit", response.body.studyFeatures);

          this.toggleFeatures.forEach(feature => {
            if (feature.featureKey === "EDC") {
              this.edcEnabled = feature.enabled;
            }
            if (feature.featureKey === "TruClinic") {
              this.telehealthEnabled = feature.enabled;
            }
            if (feature.featureKey === "ANALYTICS_DASHBOARD") {
              this.analyticsEnabled = feature.enabled;
            }

            if (feature.featureKey === "TELEHEALTH") {
              this.isTelehealthV2Enabled = feature.enabled;
            }
          });
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting features.");
        }
      );
    },
    getUserObj() {
      const userObj = localStorageService.getItem("userObj");
      this.selectedSiteId = userObj && userObj.siteIds && userObj.siteIds[0];
      this.userDefineSiteId = userObj && userObj.userSite && userObj.userSite.find(item => item.siteId == this.selectedSiteId).userDefineSiteId;
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(response => {
        window.localStorage.removeItem("studyDetailsData");
        window.localStorage.setItem("studyDetailsData", JSON.stringify(response.body));
        this.studyData = response.body;
      });
    },
    modifyStudy() {
      window.localStorage.setItem("thread-studySummary", true);
      this.$router.push({
        name: "study-summary",
        params: { studyId: this.studyId }
      });
    },
    getParticularPIrole() {
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock") {
        this.$api.getSiteDetailsFact(this.studyId, this.user.siteIds[0]).then(response => {
          window.localStorage.removeItem("getSiteIdDetails");
          window.localStorage.setItem("getSiteIdDetails", JSON.stringify(response.body));
          this.piRoleUniqueId = response.body.userSiteId;
          this.setSiteDetailsData(response.body);
        });
      }
    },
    async getMaterialCount() {
      this.newResourceCount = 0;
      this.materialCount = 0;
      this.newAnnCount = 0;
      this.newLinksCount = 0;
      this.getMaterialData();
      this.getLinksData();
      this.getAnnouncementData();
      await this.gettedmaterialsData.map(el => {
        const datevalue = new Date(el.createdTime);
        const currentDate = new Date();
        const diffDays = parseInt((currentDate - datevalue) / (1000 * 60 * 60 * 24), 10);
        if (diffDays <= 10) {
          this.materialCount++;
        }
      });
      await this.newLinksData.map(el => {
        const datevalue = new Date(el.createdTime);
        const currentDate = new Date();
        const diffDays = parseInt((currentDate - datevalue) / (1000 * 60 * 60 * 24), 10);
        if (diffDays <= 10) {
          this.newLinksCount++;
        }
      });
      await this.newAnnouncementData.map(el => {
        const datevalue = new Date(el.createdTime);
        const currentDate = new Date();
        const diffDays = parseInt((currentDate - datevalue) / (1000 * 60 * 60 * 24), 10);
        if (diffDays <= 10) {
          this.newAnnCount++;
        }
      });
      this.newResourceCount = this.materialCount + this.newAnnCount + this.newLinksCount;
      return this.newResourceCount;
    },
    getMaterialData() {
      let materialData = JSON.parse(window.localStorage.getItem("materialData"));
      let materialOrderSequence = [];
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock") {
        materialOrderSequence = _.orderBy(materialData, "createdTime", "desc");
        let dataResource = [];
        let dataSitesResource = [];
        const overallListResource = [];
        materialOrderSequence.forEach(elementData => {
          dataResource = elementData;
          dataSitesResource = elementData.studySiteMeta;
          dataSitesResource.forEach(elementList => {
            if (elementList.siteId == this.piRoleUniqueId) {
              overallListResource.push(dataResource);
            }
          });
        });
        materialOrderSequence = _.orderBy(overallListResource, "createdTime", "desc");
        this.gettedmaterialsData = materialOrderSequence;
      } else if (this.user.userRole == "Cra" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole === "CraUB") {
        materialData = _.orderBy(materialData, "createdTime", "desc");
        this.gettedmaterialsData = materialData.filter(el => {
          return el.userRole == "SystemAdmin" || el.userRole == "StudyAdmin";
        });
      } else {
        materialOrderSequence = _.orderBy(materialData, "createdTime", "desc");
        this.gettedmaterialsData = materialOrderSequence;
      }
    },
    getLinksData() {
      let linksData = JSON.parse(window.localStorage.getItem("linksData"));
      let materialOrderSequence = [];
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock") {
        materialOrderSequence = _.orderBy(linksData, "createdTime", "desc");
        let dataResource = [];
        let dataSitesResource = [];
        const overallListResource = [];
        materialOrderSequence.forEach(elementData => {
          dataResource = elementData;
          dataSitesResource = elementData.studySiteMeta;
          dataSitesResource.forEach(elementList => {
            if (elementList.siteId == this.piRoleUniqueId) {
              overallListResource.push(dataResource);
            }
          });
        });
        materialOrderSequence = _.orderBy(overallListResource, "createdTime", "desc");
        this.newLinksData = materialOrderSequence;
      } else if (this.user.userRole == "Cra" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole === "CraUB") {
        linksData = _.orderBy(linksData, "createdTime", "desc");
        this.newLinksData = linksData.filter(el => {
          return el.userRole == "SystemAdmin" || el.userRole == "StudyAdmin";
        });
      } else {
        materialOrderSequence = _.orderBy(linksData, "createdTime", "desc");
        this.newLinksData = materialOrderSequence;
      }
    },
    getAnnouncementData() {
      const announceData = JSON.parse(window.localStorage.getItem("announcementData"));
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock") {
        let materialOrderSequence = _.orderBy(announceData, "createdTime", "desc");
        let dataResource = [];
        let dataSitesResource = [];
        const overallListResource = [];
        materialOrderSequence.forEach(elementData => {
          dataResource = elementData;
          dataSitesResource = elementData.studySiteMeta;
          dataSitesResource.forEach(elementList => {
            if (elementList.siteId == this.piRoleUniqueId) {
              overallListResource.push(dataResource);
            }
          });
        });
        materialOrderSequence = _.orderBy(overallListResource, "createdTime", "desc");
        this.newAnnouncementData = materialOrderSequence;
      } else if (this.user.userRole == "Cra" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole === "CraUB") {
        const annData = _.orderBy(announceData, "createdTime", "desc");
        this.newAnnouncementData = annData.filter(el => {
          return el.userRole == "SystemAdmin" || el.userRole == "StudyAdmin";
        });
      } else {
        const materialOrderSequence = _.orderBy(announceData, "createdTime", "desc");
        this.newAnnouncementData = materialOrderSequence;
      }
    }
  }
};
</script>
<style scoped lang="scss" src="./styles/main-header.scss" />
<style scoped>
.d-custom-lg-none {
  display: none !important;
}
.desk-view-studie {
  display: block !important;
}

@media (min-width: 320px) and (max-width: 1111px) {
  .d-custom-lg-none {
    display: block !important;
  }
  .desk-view-studie {
    display: none !important;
  }
}
</style>
